import React from "react"

import { withSearchPagination } from "./withSearchPagination"
import { Pagination } from "../../Pagination/Pagination"

export const SearchPagination = withSearchPagination(
  ({ active, currentPage, handlePageChange, totalPages }): JSX.Element =>
    active ? <Pagination currentPage={currentPage} totalPageCount={totalPages} handlePageChange={handlePageChange} /> : null
)
